import { trpc } from '@/shared/api';

interface UserDetailQueryOptions {
  readonly enabled?: boolean;
}

/**
 * 관리자 회원 상세(users.adminGet) — 계정 정보·차단 사유·로그인 수단·활동 수.
 *
 * 열 때마다 서버가 개인정보 접근 기록(PII_ACCESSED)을 남기므로 창 포커스·재연결로는 다시 부르지 않는다.
 * 차단·해제 뒤에는 features/users 의 무효화가 다시 읽게 한다.
 */
export const useUserDetailQuery = (userId: string, options: UserDetailQueryOptions = {}) =>
  trpc.users.adminGet.useQuery(
    { userId },
    {
      enabled: options.enabled ?? true,
      // 없는 회원(NOT_FOUND)은 재시도해도 같다.
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  );
